import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import './FileDropzone.css';

interface FileDropzoneProps {
  onFileUpload: (file: File) => void;
  onClose?: () => void;
  isFullPage?: boolean;
}

const FileDropzone: React.FC<FileDropzoneProps> = ({ onFileUpload, onClose, isFullPage = false }) => {
  const onDrop = useCallback(
    (acceptedFiles: File[]) => {
      if (acceptedFiles.length > 0) {
        onFileUpload(acceptedFiles[0]);
      }
    },
    [onFileUpload]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      'text/csv': ['.csv'],
      'text/plain': ['.csv'],
      'application/vnd.ms-excel': ['.csv'],
      'application/octet-stream': ['.csv'],
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
    },
    maxFiles: 1,
  });

  if (isFullPage) {
    return (
      <div className="file-dropzone-fullpage">
        {onClose && (
          <button className="close-button-top" onClick={onClose}>
            ← Back to Properties
          </button>
        )}
        <div {...getRootProps()} className={`dropzone-fullpage ${isDragActive ? 'active' : ''}`}>
          <input {...getInputProps()} />
          <div className="dropzone-content">
            <svg
              width="64"
              height="64"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              className="dropzone-icon"
            >
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
              <polyline points="17 8 12 3 7 8" />
              <line x1="12" y1="3" x2="12" y2="15" />
            </svg>
            {isDragActive ? (
              <p className="dropzone-text">Drop the CSV/XLSX file here...</p>
            ) : (
              <>
                <p className="dropzone-text">
                  Drag and drop a CSV/XLSX file here, or click to select
                </p>
                <p className="dropzone-hint">
                  Required: Full Address, or Address + City + State. Optional: Zipcode (or Zip Code), Phone.
                </p>
              </>
            )}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="file-dropzone-overlay" onClick={onClose}>
      <div className="file-dropzone" onClick={(e) => e.stopPropagation()}>
        <button className="close-button" onClick={onClose}>
          ×
        </button>
        <div {...getRootProps()} className={`dropzone ${isDragActive ? 'active' : ''}`}>
          <input {...getInputProps()} />
          <div className="dropzone-content">
            <svg
              width="48"
              height="48"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              className="dropzone-icon"
            >
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
              <polyline points="17 8 12 3 7 8" />
              <line x1="12" y1="3" x2="12" y2="15" />
            </svg>
            {isDragActive ? (
              <p className="dropzone-text">Drop the CSV/XLSX file here...</p>
            ) : (
              <>
                <p className="dropzone-text">
                  Drag and drop a CSV/XLSX file here, or click to select
                </p>
                <p className="dropzone-hint">
                  Required: Full Address, or Address + City + State. Optional: Zipcode (or Zip Code), Phone.
                </p>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FileDropzone;
